export default function validationPlanMedia(response, messages) {
  if (!response.data || !response.data.error || !response.data.error.validationErrors) {
    return;
  }
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('SUM_MUST_BE_100') === 0) {
      messages.push({ message: 'addEditPlanMedia.validation.sumCommissions' });
    }
    if (message.indexOf('MULTI_CUSTOMER') === 0) {
      messages.push({
        message: 'addEditPlanMedia.validation.multiCustomer',
      });
    }
    if (message.indexOf('LEAST_ONE_ADVERTISER') === 0) {
      messages.push({
        message: 'addEditPlanMedia.validation.leastOneAdvertiser',
      });
    }
    if (message.indexOf('PROSPECT_NOT_ALLOWED') === 0) {
      messages.push({
        message: 'addEditPlanMedia.validation.prospectNotAllowed',
      });
    }
    if (message.indexOf('LEAST_ONE_PAYER') === 0) {
      messages.push({
        message: 'addEditPlanMedia.validation.leastOnePayer',
      });
    }
    if (message.indexOf('NOT_SAME_DIVISION_TYPE') === 0) {
      messages.push({
        message: 'addEditPlanMedia.validation.notSameDivisionType',
      });
    }
    if (message.indexOf('ACCOUNTING_RECIPIENT_ONLY_ALLOWED_ON_A_BILL') === 0) {
      messages.push({
        message: 'addEditPlanMedia.validation.accountingRecipientOnlyAllowedOnABill',
      });
    }
    if (message.indexOf('POURCENTAGE_DIVISION') === 0) {
      messages.push({
        message: 'addEditPlanMedia.validation.pourcentageDivision',
      });
    }
  });
}
